import { useState } from 'react';

const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word.slice(0, 1))
    .join('')
    .toUpperCase();

export const EntityLogo = ({
  name,
  url,
  className = 'size-5',
}: {
  name: string;
  url?: string | null;
  className?: string;
}) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  return url && url !== failedUrl ? (
    <img
      src={url}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailedUrl(url)}
      className={`shrink-0 rounded object-contain ${className}`}
    />
  ) : (
    <span
      aria-hidden="true"
      className={`flex shrink-0 items-center justify-center rounded bg-raised text-xs font-medium text-muted ${className}`}
    >
      {initialsOf(name)}
    </span>
  );
};
